var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.50293 4C0.50293 1.79086 2.29379 0 4.50293 0H13.5029C15.7121 0 17.5029 1.79086 17.5029 4V4.95855L21.0029 2.93782C21.6696 2.55292 22.5029 3.03405 22.5029 3.80385V14.1962C22.5029 14.966 21.6696 15.4471 21.0029 15.0622L18.7224 13.7455L18.9391 13.5287C20.1192 12.3487 20.1192 10.4354 18.9391 9.25527C17.759 8.07518 15.8457 8.07518 14.6656 9.25527L14.367 9.55392L13.931 9.11795C12.8136 8.00048 11.0018 8.00048 9.88431 9.11795C8.76684 10.2354 8.76684 12.0472 9.88431 13.1647L10.3203 13.6006L9.93126 13.9896C8.83533 15.0856 8.75718 16.8139 9.69681 18H4.50293C2.29379 18 0.50293 16.2091 0.50293 14V4Z",
    fill: "#888888"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.0509,
    y: 11.0407,
    width: 2.50034,
    height: 9.99525,
    rx: 1.25017,
    transform: "rotate(-45 10.0509 11.0407)",
    fill: "#888888"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1179,
    y: 9.27338,
    width: 2.50034,
    height: 9.99525,
    rx: 1.25017,
    transform: "rotate(45 17.1179 9.27338)",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOn);
export default __webpack_public_path__ + "static/media/cameraOn.619aa833149da0f30d4a9ca743857d30.svg";
export { ForwardRef as ReactComponent };